<div
  class="mx-auto w-full max-w-[820px] flex flex-col pt-8 pb-4 md:pt-16 gap-6"
  [formGroup]="schoolForm">
  <div
    class="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
    <div
      class="flex items-start gap-5 px-10 pt-10 pb-6 border-b border-gray-100">
      <div
        class="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-[#547bf5] shadow-[0_4px_6px_0_#c7d9fe,0_10px_15px_0_#c7d9fe]">
        <img
          src="/assets/onboarding/welcome-school.svg"
          alt=""
          class="h-7 w-7 select-none"
          draggable="false" />
      </div>
      <div class="min-w-0 pt-0.5">
        <h1
          class="font-bold text-2xl min-[360px]:text-3xl text-[#111827] leading-tight m-0">
          Schuleinheitsprofil einrichten
        </h1>
        <p class="text-base text-[#6b7280] mt-2 m-0">
          Erfasse die Minimalangaben deiner Schuleinheit.
        </p>
      </div>
    </div>

    <div class="px-6 sm:px-10 py-8 flex flex-col gap-10">
      <div
        class="rounded-xl border border-[#e0eaff] bg-[rgba(240,244,255,0.5)] p-8 flex flex-col gap-8">
        <mat-form-field class="w-full">
          <mat-label>Name der Schule / Einheit</mat-label>
          <input
            matInput
            type="text"
            formControlName="schoolName"
            placeholder="z.B. Primarschule Zürich Nord" />
          <mat-error>Name ist erforderlich</mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>Kooperationsschule (optional)</mat-label>
          <mat-select formControlName="institutionId">
            <mat-option value="">Bitte wählen</mat-option>
            @for (inst of institutions; track inst.id) {
              <mat-option [value]="inst.id">{{ inst.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>Schulart</mat-label>
          <mat-select formControlName="schoolType" placeholder="Bitte wählen">
            @for (type of schoolTypes; track $index) {
              <mat-option [value]="type">
                {{ type }}
              </mat-option>
            }
          </mat-select>
          <mat-error>Schulart ist erforderlich</mat-error>
        </mat-form-field>

        <app-level-capture
          class="mb-4"
          [levelsControl]="schoolForm.controls.levels"
          [descriptionsControl]="schoolForm.controls.levelDescriptions" />

        <div
          class="grid grid-cols-1 sm:grid-cols-2 gap-4 border-t border-[rgba(199,217,254,0.3)] pt-6">
          <mat-form-field class="w-full">
            <mat-label>Anzahl Mitarbeitende</mat-label>
            <input
              matInput
              type="number"
              min="0"
              formControlName="countEmployees"
              placeholder="z.B. 50" />
            <mat-error>Bitte eine gültige Zahl eingeben.</mat-error>
          </mat-form-field>
          <mat-form-field class="w-full">
            <mat-label>Anzahl Lernende</mat-label>
            <input
              matInput
              type="number"
              min="0"
              formControlName="countStudents"
              placeholder="z.B. 300" />
            <mat-error>Bitte eine gültige Zahl eingeben.</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div
        class="flex flex-col gap-4 border-t border-[rgba(199,217,254,0.5)] pt-6">
        <h2 class="text-base font-semibold text-[#111827] m-0">
          Standort &amp; Über uns
        </h2>
        <app-address-autocomplete-field
          [initialZipcode]="
            schoolForm.controls.schoolZipcode.value || undefined
          "
          [initialCity]="schoolForm.controls.schoolCity.value || undefined"
          [initialAddress]="schoolForm.controls.schoolStreet.value || undefined"
          [initialStreetNumber]="
            schoolForm.controls.schoolStreetNumber.value || undefined
          "
          (locationResolved)="onSchoolLocationResolved($event)"
          (addressComplete)="addressComplete.set($event)" />

        <mat-form-field class="w-full">
          <mat-label>Webseite (optional)</mat-label>
          <mat-icon class="material-symbols-rounded" matPrefix>public</mat-icon>
          <input
            matInput
            type="text"
            formControlName="website"
            placeholder="https://..."
            autocomplete="url" />
          <mat-error>Gib eine gültige Webseite ein.</mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>Über uns</mat-label>
          <textarea
            matInput
            placeholder="Beschreibe deine Schule..."
            formControlName="about"
            rows="8"></textarea>
        </mat-form-field>

        <div
          class="flex flex-col gap-4 border-t border-[rgba(199,217,254,0.5)] pt-6">
          <h2 class="text-base font-semibold text-[#111827] m-0">
            Kontaktperson
          </h2>
          <mat-form-field class="w-full">
            <mat-label>Ansprechperson (Admin)</mat-label>
            <mat-icon class="material-symbols-rounded" matPrefix
              >person</mat-icon
            >
            <input
              matInput
              type="text"
              formControlName="contactName"
              placeholder="z.B. Max Muster" />
          </mat-form-field>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <mat-form-field class="w-full">
              <mat-label>Email</mat-label>
              <mat-icon class="material-symbols-rounded" matPrefix
                >mail</mat-icon
              >
              <input
                matInput
                type="email"
                formControlName="contactEmail"
                placeholder="max.muster@schule.ch" />
            </mat-form-field>
            <mat-form-field class="w-full">
              <mat-label>Telefonnummer</mat-label>
              <mat-icon class="material-symbols-rounded" matPrefix
                >call</mat-icon
              >
              <input
                matInput
                type="tel"
                formControlName="contactPhone"
                placeholder="+41 44 123 45 67" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div
      class="border-t border-[#f3f4f6] pt-px mt-2 flex h-[72px] items-center justify-end gap-4 px-6 sm:px-10">
      <button (click)="onBackClick()" mat-button color="primary" type="button">
        Zurück
      </button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="onContinue()">
        Profil speichern und weiter
      </button>
    </div>
  </div>
</div>
